import { defineComponent as _defineComponent } from 'vue';
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryArchiveSimple',
    emits: ["onArchive"],
    setup(__props, { emit }) {
        function onArchiveHistory() {
            emit("onArchive");
        }
        return { __sfc: true, emit, onArchiveHistory, BButton };
    }
});
